let header = document.querySelector(".header")
let headerBtn = document.querySelector(".header__innerBurger")
let headerClose = document.querySelector(".header__orInnerClose")
let headerBg = document.querySelector(".header__orBg")

headerBtn.addEventListener("click", () => {
    header.classList.toggle("is-on");
    if (header.classList.contains("is-on")) {
        document.body.style.overflowY = "hidden"
        document.documentElement.style.overflowY = "hidden"
    } else {
        document.body.style.overflowY = ""
        document.documentElement.style.overflowY = ""
    }
})

headerClose.addEventListener("click", closeMenu)
headerBg.addEventListener("click", closeMenu)

function closeMenu() {
    header.classList.remove("is-on");
    document.body.style.overflowY = ""
    document.documentElement.style.overflowY = ""
}

window.addEventListener("scroll", () => {
    if (window.scrollY >= window.innerWidth * 0.1) {
        document.body.classList.add("notTop")
    } else {
        document.body.classList.remove("notTop")
    }
})